<template>
  <div v-if="obj">
    <van-popup v-model="visible" :close-on-click-overlay="false" position="top">
      <van-sticky offset-top="0">
        <div class="title" @click="close">
          <i class="el-icon-back C2" />
          {{ obj.DispName }} ${{ obj.Price1 }}
        </div>
      </van-sticky>

      <div class="main">
        <!-- {{ gCheckItemcData(obj) }} -->
        <van-image
          :src="obj.ImgFile"
          lazy-load
          width="200"
          @click="preview = true"
          :show-error="false"
        />
        <van-image-preview v-model="preview" :images="[obj.ImgFile]" :showIndex="false" />
        <div class="remark" v-html="gNl2br(gGetIcon(obj.Remark))" />
        <div v-if="gGetDcText(obj)">
          <van-tag size="large" type="danger" plain>{{ gGetDcText(obj) }}</van-tag>
        </div>
        <!-- {{ obj }} -->
        <!-- GROUPS -->
        <!-- {{ gCheckS1Data(obj) }} -->

        <ItemGroups :groups="obj.Groups" @click="showDetailGroup" />
        <Stepper :item="obj" :doAmt="sumItemAmt().doAmt" />
        <Footer
          v-if="obj.rno"
          :b1="getBtnText()"
          @b1c="finish()"
          b0="刪除餐點 Remove"
          @b0c="cmdDelete()"
          :anime="anime"
        />

        <Footer v-else :b1="getBtnText()" @b1c="add()" :anime="anime" />
      </div>
      <FrmItemDetailGroup ref="rItemDetailGroup" />
    </van-popup>
  </div>
</template>

<style scoped>
.remark {
  margin: 0.3rem 0 0.3rem 0;
  line-height: 1.6rem;
}
.title {
  background-color: rgba(255, 255, 255, 0.95);
  font-size: 1.6rem;
  padding: 1rem;
  z-index: 999;
  text-align: left;
}
.van-popup {
  width: 100%;
  height: 100%;
}
.main {
  padding: 1rem;
  padding-top: 0;
  text-align: left;
}
</style>

<script>
// import UserNote from "./Child/UserNote.vue";
var fits = require("../../../../js/lib-fits-front.js");
import ItemGroups from "./Child/ItemGroups.vue";
import Stepper from "./Child/Stepper.vue";
import Footer from "./Child/Footer.vue";
// import FrmItemDetailGroup from "./FrmItemDetailGroup.vue";

export default {
  components: {
    ItemGroups,
    Stepper,
    Footer,
    // FrmItemDetailGroup,
  },
  data() {
    return {
      visible: false,
      obj: null,
      preview: false,
      itemnote: "",
      anime: false,
    };
  },
  methods: {
    add() {
      this.$emit("add", this.obj);
      this.visible = false;
    },
    async finish() {
      try {
        // if (this.gOverSendTime()) return this.gMsgbox("已達用餐限點時間");

        if (!this.checkData()) {
          this.gMsgbox("請確認附餐必選項目", "Side Check");
          return;
        }
        this.gLoading();
        var body = { item: this.obj };
        if (this.obj.rno == undefined) {
          await this.apiAddItem(body);
          this.gMsg("加入:" + this.obj.ItemName + "x" + this.obj.Qty);
        } else {
          await this.apiUpdItem(body);
          this.gMsg("更新:" + this.obj.ItemName + "x" + this.obj.Qty);
        }

        this.$emit("callback", this.obj);
        this.close();
        this.gClearLoading();
      } catch (error) {
        console.log(error);
      }
    },
    showDetailGroup(obj) {
      console.log("!3", obj);
      this.$refs.rItemDetailGroup.show(obj);
    },

    onChangePriceCap(priceCap) {
      console.log("onChangePriceCap", JSON.stringify(priceCap));
      this.obj.Price1 = priceCap.Price;
    },
    appendUserNote() {
      let row = {
        id: "userNote",
        text: "",
        type: "A1",
        limit: "0",
        lock: true,
        num: false,
        remark: "",
        options: [
          {
            TypeNo: 4,
            ItemNo: 1,
            ItemName: "",
            ItemType: "-",
            Price1: 0,
            Price2: 0,
            Price3: 0,
            KPtype: this.obj.KPtype,
            OpenCode: "N",
            ImgFile: "",
            ItemCode: "",
            AvailTime: "",
            CtrlFlag: "",
            Price1Cap: "",
            Price2Cap: "",
            Price3Cap: "",
            DispName: "",
            Groups: [],
            Qty: 1,
            DefaultQty: 1,
          },
        ],
        key: fits.uuid(),
      };
      // this.obj.Groups.push(row);
      this.obj.Groups.splice(0, 0, row);
      console.log("obj", JSON.stringify(this.obj));
    },
    async show(obj) {
      try {
        console.log("in show detail");
        if (obj.rno) {
          this.obj = obj;
          return (this.visible = true);
        }
        this.gLoading();
        var query = { typeno: obj.TypeNo, itemname: obj.ItemName };
        var res = await this.apiGetItemC(query);
        this.obj = res.data;

        if (this.$store.getters.getConfig("userNote")) this.appendUserNote(this.obj);
        // console.log(JSON.stringify(this.obj));
        this.visible = true;
        this.gClearLoading();
      } catch (error) {
        console.log(error);
        this.gClearLoading();
      }
    },
    close() {
      this.obj = null;
      this.visible = false;
    },
    // getBtnText() {
    //   this.anime = this.checkData();

    //   if (this.obj.rno) {
    //     return "更新餐點 Update";
    //   }

    //   return "加入" + this.obj.Qty + "份  $" + this.sumItemAmt() + " Add";
    //   // return "加入" +;
    // },
    getBtnText() {
      if (!this.checkData()) {
        this.anime = false;
        return "請選擇附餐 Side Check";
      }

      this.anime = true;
      if (this.obj.rno) {
        return "更新餐點 Update";
      }

      if (this.$store.getters.getConfig("chkCartNoSumAmt"))
        return "加入" + this.obj.Qty + "份  " + " Add " + this.obj.Qty;

      return (
        "加入" + this.obj.Qty + "份  $" + this.sumItemAmt().amt + " Add " + this.obj.Qty
      );
    },
    sumItemAmt() {
      var obj = this.obj;
      var rst = this.gGetItemcRst(obj);
      console.log("sumItemAmt", rst[0].Qty, obj.Discount);
      if (rst.length == 0) {
        return 0;
      }
      var s1Qty = rst[0].Qty;
      // console.log("s1Qty", s1Qty);
      rst[0].Qty = 1;
      // console.log("s1", s1Qty);
      rst.map((r) => (r.Amt = r.Price1 * r.Qty));
      var sum = this.gSum(rst, "Amt");
      var doAmt = this.gCalcDcAmt(s1Qty, sum, obj.Discount);
      var original = sum * s1Qty;
      var amt = original + doAmt;
      return { original: original, doAmt: doAmt, amt: amt };
    },
    async cmdDelete() {
      try {
        this.gMsgbox(
          "刪除:" + this.obj.ItemName + "x" + this.obj.Qty,
          "刪除 Remove"
        ).then(async () => {
          this.gLoading();
          this.obj.Qty = 0;
          var body = { item: this.obj };
          await this.apiUpdItem(body);
          this.$emit("callback");
          this.close();
          this.gClearLoading();
        });
      } catch (error) {
        console.log(error);
        this.gClearLoading();
      }
    },
    checkData() {
      var checked = this.gCheckS1Data(this.obj);
      if (!checked) {
        return false;
      }
      return true;
    },
  },
};
</script>
